<template>
  <div id="searchPage" :style='{display: showFlag }'>
    <div class="Search_top">
      <div class="search">
        <div class="back" @click="changeFlag()"><i class="iconfont icon-guanbi"></i></div>
        <mt-search v-model="value" @input.native='inputSearchData' autofocus :result.sync="result" show
                   :cancel-text="$t('cancel')">
          <div class="history clearfix" style="" v-show='!value&&hsSearch.length!=0'>
            <div class="his_top">
              <div class="his_left">{{$t('opera_search_history')}}</div>
              <div class="his_right"><i class="iconfont icon-icon1460188478041" @click='delHistory'></i></div>
            </div>
            <ul class="content clearfix">
              <li class="option" v-for='item in hsSearch' @click='setHotel(item)'>
                {{item.descript}}
              </li>
            </ul>
          </div>
          <mt-cell
            v-for="(item,itemKey) in result"
            :key='item.code'
            :title="item.descript"
            :value="item.levelDescript"
            @click.native='selectHotel(item)' :class='{noborder:itemKey==1}'>
          </mt-cell>
        </mt-search>
      </div>

    </div>

  </div>

</template>

<script>

  import _ from 'lodash';

  export default {
    data() {
      return {
        hsSearch: localStorage.hsSearch ? JSON.parse(localStorage.hsSearch) : [],
        searchText: '',
        value: '',
        result: []
      }
    },
    props: {
      showFlag: String,
    },
    mounted() {
      // this.getallHotel();
    },
    methods: {
      searchData() {
        this.$http.post('/mobilepmsapi/sys/searchHotel', {q: this.value}).then(res => {
          this.result = res.data.retVal;
        })
      },
      inputSearchData: _.debounce(function () {
        this.searchData()
      }, 1000),
      delHistory() {
        localStorage.setItem('hsSearch', '')
        this.hsSearch = []
      },
      selectHotel(item) {
        if (!_.find(this.hsSearch, item)) {
          if (this.hsSearch.length == 3) {
            this.hsSearch.shift()
          }
          this.hsSearch.push(item)
        }
        localStorage.setItem('hsSearch', JSON.stringify(this.hsSearch))
        this.setHotel(item)
      },
      setHotel(item) {
        this.$emit('searchResult', item);
      },

      changeFlag() {
        this.$emit('changeFlag');
      }
    },
    watch: {
      showFlag(curVal, oldVal) {
        if (curVal == 'block') {
          this.searchData();
        }
      },
    }
  }
</script>

<style lang='less'>
  #searchPage {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    width: 100%;
    background: #fff;
    height: 100%;

    .mint-searchbar {
      background: none;
      border-radius: 5px;
    }

    .mint-searchbar-inner {
      background: #efefef;
      border-radius: 1rem;
    }

    .mint-searchbar-core {
      text-indent: 0.3rem;
      background: #efefef;
    }

    .mintui-search {
      font-size: 0.5rem;
      margin-left: 0.2rem;
    }

    .mint-searchbar-cancel {
      color: #000
    }

    .mint-cell-wrapper {
      font-size: 0.35rem;
      border-bottom: 1px solid #ccc;
      width: 90%;
      margin: 0 auto;
    }

    .Search_top {

      background-color: #fff;
      height: 1.666667rem;

      .search {
        .back {
          float: left;
          width: 22px;
          line-height: 52px;
          padding-left: 10px;
          position: relative;
          z-index: 3;

          .icon-guanbi {
            font-size: 20px;
            color: #666;
          }
        }
      }
    }

    .history {
      margin-top: 5px;
      background-color: #fff;

      .his_top {
        background: #ffffff;
        width: 345px;
        height: 39px;
        box-sizing: border-box;
        margin: 0 auto;
        line-height: 39px;
        border-bottom: 1px solid #ddd;

        .his_left {
          float: left;
          font-size: 12px;
          color: #666666;
        }

        .his_right {
          float: right;

          .iconfont {
            font-size: 16px;
          }
        }
      }

      .content {
        padding: .5rem .8rem;

        .option {
          margin: 8px 5px;
          padding: 0 10px;
          border-radius: 100px;
          border: 1px solid #dddddd;
          float: left;
          height: 28px;
          box-sizing: border-box;
          line-height: 28px;
          color: #333333;
          font-size: 14px;
        }
      }
    }

    .recommend {
      margin-top: 5px;
      background-color: #fff;

      .rec_top {
        background: #ffffff;
        width: 345px;
        height: 39px;
        box-sizing: border-box;
        margin: 0 auto;
        line-height: 39px;
        border-bottom: 1px solid #ddd;

        .rec_left {
          float: left;
          font-size: 12px;
          color: #666666;
        }

        .rec_right {
          float: right;

          .iconfont {
            font-size: 16px;
          }
        }
      }

      .content {
        padding: .5rem .8rem;

        .option {
          margin: 8px 3px;
          padding: 0 10px;
          border-radius: 100px;
          border: 1px solid #dddddd;
          float: left;
          height: 28px;
          box-sizing: border-box;
          line-height: 28px;
          color: #333333;
          font-size: 14px;
        }
      }
    }

    .mint-search-list-warp .mint-cell:nth-of-type(1) .mint-cell-wrapper {
      background-image: none;
    }
  }
</style>



// WEBPACK FOOTER //
// search.vue?a2aab982